import axios from 'axios';

import {
    API_BASE_URL,
    KYB_API_BASE_URL
} from '../../constants/index';

export default class LicenseManagementService {
	static getInstance() {
		if (!LicenseManagementService.instance) {
			LicenseManagementService.instance = new LicenseManagementService();
		}

		return LicenseManagementService.instance;
	}

    async fetchEUDRLicenseDetail(params = {}){
        const response = await axios.get(`${API_BASE_URL}/eudr/license/info`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data.data
    }

    async fetchLimits(){
        const response = await axios.get(`${API_BASE_URL}/organization/licences/limits`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data.data
    }

    async fetchkYBLicenseDetail(params = {}){
        const response = await axios.get(`${KYB_API_BASE_URL}/kyb/license/info`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data.data
    }

    async fetchKYBLicenseUsage(params = {}){
        const response = await axios.get(`${KYB_API_BASE_URL}/kyb/license/usage`, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async fetchKYBLicenseUsageExport(params = {}){
        const response = await axios.get(`${KYB_API_BASE_URL}/kyb/license/usage/export`, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async fetchComplianceCredits(params = {}){
        const response = await axios.get(`${KYB_API_BASE_URL}/kyb/license/compliance-monitoring-credits`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    async fetchComplianceTotalCredits(params = {}){
        const response = await axios.get(`${KYB_API_BASE_URL}/kyb/license/compliance-monitoring-credits-only`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }
}
